<template>
    <h4>Ингредиенты</h4>
    {{shit}}
    <ul>
      <li v-for="i in ingredients">- {{ i }}</li>
    </ul>
</template>



<script>
export default {
  name: "Ingredients",
  props: {
    shit: String,
    ingredients: Array,
  }
};
</script>



<style scoped>

</style>